import moduleStepState from './moduleStepState';
const { steps } = moduleStepState;
export default {
  incrementCurrentStep: ({ commit, state }) => {
    let nextStep = state.currentStep + 1;
    while (nextStep < state.steps.length && !state.steps[nextStep]) {
      nextStep++;
    }
    if (nextStep < state.steps.length) {
      commit("UPDATE_CURRENT_STEP", { order: nextStep });
    }
  },

  decrementCurrentStep: ({ commit, state }) => {
    let prevStep = state.currentStep - 1;
    while (prevStep >= 0 && !state.steps[prevStep]) {
      prevStep--;
    }
    if (prevStep >= 0) {
      commit("UPDATE_CURRENT_STEP", { order: prevStep });
    }
  },

  updateCurrentStep: ({ commit }, payload) =>
    commit("UPDATE_CURRENT_STEP", payload),

  completeStep: ({ commit }) => commit("COMPLETE_STEP"),

  updateBasicFormSubmit: ({ commit }, payload) =>
    commit("UPDATE_BASIC_FORM_SUBMIT", payload),

  parseStepsInformation: ({ dispatch }, payload) => {
    const {
      basic,
      address,
      talent,
      formations,
      experiences,
      languages,
      skills,
      professional_profile
    } = payload["data"].data;

    dispatch("basicInfo/store", { ...basic }, { root: true });
    dispatch("address/setAddress", { ...address }, { root: true });
    dispatch("formation/index", formations, { root: true });
    dispatch("experience/index", experiences, { root: true });
    dispatch("language/index", languages, { root: true });
    dispatch("skill/index", skills, { root: true });
    dispatch("talent/addTalent", talent, { root: true });
    dispatch(
      "professional_profile/addProfessionalProfile",
      professional_profile,
      { root: true }
    );

    return payload;
  },

  perfomSucessfullResponse: ({ dispatch }, payload) => {
    let data = {};

    if (payload.data !== undefined || payload.data !== null)
      data = { ...payload["data"].data };

    if (data !== undefined || data !== null) {
      Object.keys(data).map(key => {
        switch (key) {
          case "basicInfo":
            dispatch("basicInfo/setBasic", { ...data[key] }, { root: true });
            break;
          case "address":
            dispatch("address/setAddress", { ...data[key] }, { root: true });
            break;
          case "formations":
            data[key].map(
              async item =>
                await dispatch("formation/update", { ...item }, { root: true })
            );
            break;
          case "experiences":
            data[key].map(
              async item =>
                await dispatch("experience/index", { ...item }, { root: true })
            );
            break;
          case "languages":
            data[key].map(
              async item =>
                await dispatch("language/index", { ...item }, { root: true })
            );
            break;
          case "skills":
            data[key].map(
              async item =>
                await dispatch("skill/index", { ...item }, { root: true })
            );
            break;

          default:
            break;
        }
      });
    }
  },

  completeStepsAfterParse: async ({ commit, rootGetters }) => {
    const stepValidations = [
      { index: 0, getter: "basicInfo/emptyBasic" },
      { index: 0, getter: "basicInfo/emptyCurriculumn" },
      { index: 1, getter: "address/emptyAddress" },
      { index: 3, getter: "formation/emptyFormation" },
      { index: 4, getter: "experience/emptyExperience" },
      { index: 5, getter: "language/emptyLanguage" },
      { index: 6, getter: "skill/emptySkill" }
    ];

    await Promise.all(
      stepValidations.map(async ({ index, getter }) => {
        if (!rootGetters[getter]) {
          await commit("COMPLETE_STEPS_AFTER_PARSER", { index });
        }
      })
    );
  },

  clearStepsState: ({ commit }) => {
    const stepsCopy = JSON.parse(JSON.stringify(steps));
    commit("CLEAR_CURRENT_STEP", 0);
    commit("CLEAR_SECOND_STEP", 0);
    commit("CLEAR_STEP_STEP", { progress: 10 });
    commit("CLEAR_STEPS", stepsCopy);
    commit("CLEAR_BASIC_FORM_SUBMIT", { trigger: false, goTo: undefined });
  },

  updateStepsDynamically: ({ commit, state }, { keywords, roles }) => {
    let stepsCopy = JSON.parse(JSON.stringify(state.steps));
    const complementaryIndex = stepsCopy.findIndex(
      s => s.path === 'step-complementary-questions'
    );
    if ((!keywords || keywords.length === 0) && (!roles || roles.length === 0)) {
      if (complementaryIndex !== -1) {
        stepsCopy.splice(complementaryIndex, 1);
      }
    } else {
      if (complementaryIndex === -1) {
        const complementaryStep = {
          title: 'Perguntas Complementares',
          icon: 'LampIcon',
          completed: false,
          current: false,
          path: 'step-complementary-questions',
          order: 8,
        };
        stepsCopy.splice(8, 0, complementaryStep);
      }
    }
    stepsCopy = stepsCopy.map((step, idx) => ({ ...step, order: idx }));
    commit('UPDATE_STEPS_DYNAMICALY', stepsCopy);
  }
};
